import { MutationTree } from 'vuex';
import { ThreadRepositoryState } from './types';
import { ThreadRepository } from '@/Classes/Infrastractures/ThreadRepository';


// actionによって変更されるフィールド
export const mutations: MutationTree<ThreadRepositoryState> = {

    setThreadRepositories: (state, threadRepository: any) => {
        // とりあえず何にでも入るのであとで項目を調節
        state.threadRepository = threadRepository;
    },
};